// import './auth.scss';

export { default } from './Auth';
export { default as template } from './auth.tpl';
